<template>
  <div class="i-calcom-scheduler">
    <div id="my-cal-inline"></div>
  </div>
</template>

<script setup lang="ts">
import { onMounted } from "vue"
import { azureRadiance50, azureRadiance600 } from "@/styles/colors"
import { useUserStore } from "@/stores/user"
import GtmService from "@/services/gtmService"

// STORES
const userStore = useUserStore()

const props = defineProps({
  embedLink: {
    type: String,
    default: ""
  },
  onBookingSuccessful: {
    type: Function,
    default: () => {}
  },
  onRescheduleSuccessful: {
    type: Function,
    default: () => {}
  }
})

// LIFECYCLE HOOKS
onMounted(() => {
  ;(function (C: Window, A: string, L: string) {
    let p = function (a: any, ar: any) {
      a.q.push(ar)
    }
    let d = C.document
    C.Cal =
      C.Cal ||
      function () {
        let cal = C.Cal
        let ar = arguments
        if (!cal.loaded) {
          cal.ns = {}
          cal.q = cal.q || []
          let script = d.createElement("script")
          script.src = A
          d.head.appendChild(script)
          cal.loaded = true
        }
        if (ar[0] === L) {
          const api = function () {
            p(api, arguments)
          }
          const namespace = ar[1]

          // @ts-expect-error - api is not typed
          api.q = api.q || []
          if (typeof namespace === "string") {
            cal.ns[namespace] = cal.ns[namespace] || api
            p(cal.ns[namespace], ar)
            p(cal, ["initNamespace", namespace])
          } else p(cal, ar)
          return
        }
        p(cal, ar)
      }
  })(window, "https://app.cal.com/embed/embed.js", "init")

  // Ensure Cal is available in the global context
  if (window.Cal) {
    window.Cal("init", { origin: "https://cal.com" })

    window.Cal("inline", {
      elementOrSelector: "#my-cal-inline",
      calLink: props.embedLink,
      layout: "column_view",
      config: {
        name: userStore.getFullName || "",
        email: userStore.getEmail || "",
        smsReminderNumber: userStore.getPhoneNumber ? userStore.getPhoneNumber : ""
      }
    })

    window.Cal("ui", {
      theme: "light",
      cssVarsPerTheme: { light: { "cal-brand": azureRadiance600, "cal-bg-emphasis": azureRadiance50 } },
      hideEventTypeDetails: false,
      layout: "column_view"
    })

    window.Cal("on", {
      action: "bookingSuccessful",
      callback: async (e: any) => {
        const slug = e?.detail?.data?.eventType?.slug || ""
        await GtmService.bookingEvent(slug)
        props.onBookingSuccessful(e)
      }
    })

    window.Cal("on", {
      action: "rescheduleBookingSuccessful",
      callback: async (e: any) => {
        const slug = e?.detail?.data?.eventType?.slug || ""
        await GtmService.rescheduleEvent(slug)
        props.onRescheduleSuccessful(e)
      }
    })
  } else {
    console.error("Cal is not defined on the window object.")
  }
})
</script>

<style lang="scss">
.i-calcom-scheduler {
  width: 100%;

  #my-cal-inline {
    width: 100%;
    height: 700px;
    overflow: scroll;
    pointer-events: auto !important;

    iframe {
      pointer-events: auto !important;
      height: 100% !important;
    }
  }
}
</style>
